

jQuery( document ).ready(function($) {

    /*
     * Navbar
     */
    // toggler effect
    $('#main-nav').on('show.bs.collapse', function() {
        $(this).removeClass('bg-white').addClass(['bg-very-light-grey', 'open']);
        $('#header-wrapper').addClass('open');
    });

    $('#main-nav').on('hide.bs.collapse', function() {
        $(this).addClass('bg-white').removeClass(['bg-very-light-grey', 'open']);
        $('#header-wrapper').removeClass('open');
        $('.site > .wrapper').removeClass('overlay');
    });

    // overlay effect
    $('#main-nav .dropdown-toggle').on('click', function() {
        let allDropdownToggles = $('#main-nav .dropdown-toggle');
        if(allDropdownToggles.hasClass('show')) {
            $('.site > .wrapper').addClass('overlay');
        } else {
            $('.site > .wrapper').removeClass('overlay');
        }
    });

    // sticky only on scroll up
    let prevScrollPos = $(window).scrollTop();
    $(window).scroll(function() {
        const currentScrollPos = $(window).scrollTop();

        if(!$('#main-nav').hasClass('open')) { // no effect if main nav open
            if (prevScrollPos > currentScrollPos) {
                // scroll to top
                $("#header-wrapper:not('.open')").addClass("sticky-top");
            } else {
                // scroll to bottom
                $("#header-wrapper:not('.open')").removeClass("sticky-top");
                $('.site > .wrapper').removeClass('overlay');
            }
        }

        prevScrollPos = currentScrollPos;
    });

    /*
     * Accordion block
     */
    $('.accordion').find('.accordion-button').on('click', function() {
        let accordionBlock = $(this).parents('.accordion-block');
        let key = $(this).attr('data-key');
        accordionBlock.find('.img-wrapper').addClass('d-none');
        accordionBlock.find('.img-'+key).removeClass('d-none');
    });

    /*
     * Forms autosubmit
     */
    $('select.auto-submit').on('change', function() {
        $(this).parents('form').submit();
    });

    /*
     * Vido card
     */
    $('.video-card').on('click', function() {
        $(this).find('img').hide();
        $(this).find('.card-img-overlay').hide();
        var player = $(this).find('iframe');
        var videoURL = player.attr('src');
        videoURL += "?rel=0&autoplay=1";
        player.attr('src',videoURL);
        player.fadeIn(1400);
    })

    /*
     * Publicaton scroll navbar
     */
    if($('body.single-publications').length) {
        let prevScrollPos = $(window).scrollTop();
        $(window).scroll(function() {
            const currentScrollPos = $(window).scrollTop();

            if(!$('#main-nav').hasClass('open')) { // don't display if main nav open
                if (prevScrollPos > currentScrollPos) {
                    // Défilement vers le haut
                    $('.publication-fixed-navbar').removeClass("sticky-top").fadeOut();
                } else {
                    // Défilement vers le bas
                    $('.publication-fixed-navbar').addClass("sticky-top").fadeIn();
                }
            }

            prevScrollPos = currentScrollPos;

            // animate scroll position
            let scrollPosition = $(document).scrollTop();
            let pageHeight = $(document).height();
            let scrollProgress = scrollPosition / pageHeight * 100;
            $('.scroll-progress').css('width', 15 + scrollProgress+'%')
        });
    }

    /*
     * Dashboard menu mobile
     */
    var mobileMenu =  $('.mobile-menu-dropdown');
    var mobileMenuButton =  mobileMenu.find('button');
    var currentDashboardMenu = $('.mobile-menu-dropdown .current-menu-item');
    mobileMenuButton.text(currentDashboardMenu.find('a').text());

    /*
     * Login form placeholders
     */
    // JS hack because no way to add it to wp_login_form()
    $('input#user_login').attr('placeholder', 'Votre email');
    $('input#user_pass').attr('placeholder', 'Votre mot de passe');
});